import { defineStore } from 'pinia';

interface DataTransfer {
  orderNumber?: any;
  slipBody?: any;
  pixData?: any;
  price?: string;
  selectedCardObject?: any;
  success?: boolean;
  cart?: any;
}

export const useThankYouStore = defineStore('thankyou', {
  state: () => ({
    orderNumber: null,
    slipData: null,
    pixData: null,
    price: null,
    selectedCardObject: null,
    success: false,
    isThankYou: false,
    cart: null,
    lastSaved: null,
  }),

  actions: {
    onPaymentSuccess(dataTransfer: DataTransfer) {
      this.orderNumber = dataTransfer.orderNumber?.value ?? null;
      this.slipData = dataTransfer.slipBody ?? null;
      this.pixData = dataTransfer.pixData ?? null;
      this.price = dataTransfer.price ?? '';
      this.cart = dataTransfer.cart ?? null;
      this.selectedCardObject = dataTransfer.selectedCardObject ?? null;
      this.success = dataTransfer.success ?? false;
      this.isThankYou = true;
      this.lastSaved = Date.now();

      this.saveState();
    },

    cleanStore() {
      this.$reset();
      localStorage.removeItem('thankyouStore');
    },

    saveState() {
      const stateToStore = {
        state: this.$state,
        timestamp: Date.now(),
      };
      localStorage.setItem('thankyouStore', JSON.stringify(stateToStore));
    },

    loadStoredState() {
      const savedData = localStorage.getItem('thankyouStore');
      if (savedData) {
        const { state, timestamp } = JSON.parse(savedData);

        if (Date.now() - timestamp < 20 * 60 * 1000) {
          Object.assign(this, state);
        } else {
          this.cleanStore();
        }
      }
    },
  },
});
